import api from './api';

/**
 * Member care plan + case actions for the Case Management side panel.
 * The api client resolves with the response body ({ success, data, error }).
 */
const MemberCarePlanService = {
  getCarePlan (patientId) {
    return api.get(`/cases/member/${encodeURIComponent(patientId)}/care-plan`);
  },

  addNote (patientId, { text, noteType }) {
    return api.post(`/cases/member/${encodeURIComponent(patientId)}/notes`, { text, noteType });
  },

  updateCase (patientId, changes) {
    return api.patch(`/cases/member/${encodeURIComponent(patientId)}/case`, changes);
  }
};

export default MemberCarePlanService;
